import { createI18n } from 'vue-i18n'

import de from './locales/de.json'
import en from './locales/en.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import nl from './locales/nl.json'
import ru from './locales/ru.json'

export const supportedLocales = ['en', 'de', 'nl', 'ru', 'fr', 'es'] as const

export type AppLocale = (typeof supportedLocales)[number]

const messages = { en, de, nl, ru, fr, es }

export function currentLocale(): AppLocale {
  const locale = document.querySelector<HTMLMetaElement>('meta[name="app-locale"]')?.content

  return supportedLocales.includes(locale as AppLocale) ? (locale as AppLocale) : 'en'
}

export function createAppI18n(locale: AppLocale = currentLocale()) {
  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    messages,
  })
}
